<template>
  <div class="default-table periodicals-table">
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="permissions.financial[subpage].actions.new"
          v-on="on"
          @click.prevent="newDialog()"
          color="primary"
          class="new-btn-float"
          app
          fab
          bottom
          right
          fixed
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.financial.periodicals.new.title}}</span>
    </v-tooltip>
    <Save
      v-if="dialog.selected"
      v-model="dialog.selected"
      :subpage="subpage"
      :id="dialog.selected.id"
      :dialog="dialog.save"
      @closed="onCloseSave"
    />
    <DataTable
      name="financial.periodicals"
      :items="data"
      :tablehdrs="tableheaders.financial.periodicals[subpage]"
      itemkey="id"
      sortby="date"
    >
      <template v-slot:default="{ item }">
        <tr
          class="table-row periodicals-row"
        >
          <td>
            {{ `# ${item.id}` }}
          </td>
          <td v-if="subpage === 'salary'">
            <Employee :value="item.ref" />
          </td>
          <td>
            {{ getPeriod(item.period) }}
          </td>
          <td class="date-col">
            {{ item.date }}
          </td>
          <td class="title-col">
            {{ item.title }}
          </td>
          <td>
            {{ formatCurrency(item.value) }}
          </td>
          <td>
            <span v-if="item.last_paid !== null" class="blue--text">
              {{ formatDate(item.last_paid, false) }}
            </span>
            <span v-else>
              {{ lang.financial.periodicals.datatable.no_one }}
            </span>
          </td>
          <td>
            <span :class="`${getDue(item).color}--text`">
              {{ getDue(item).text }}
            </span>
          </td>
          <td class="actions-col">
            <Actions
              :value="item"
              @view="viewDialog(item)"
              @edit="editDialog(item)"
              :subpage="subpage"
            />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr class="mobile_row table-row periodicals-row">
          <td class="mobile_col">
            <ul class="flex-content pl-2">
              <li class="flex-item" :data-label="lang.financial.bills.periodicals.datatable.headers.id">
                {{ `# ${item.id}` }}
              </li>
              <li v-if="subpage === 'salary'" class="flex-item" :data-label="lang.financial.bills.periodicals.datatable.headers.employee">
                <Employee :value="item.ref" />
              </li>
              <li class="flex-item" :data-label="lang.financial.bills.periodicals.datatable.headers.period">
                {{ getPeriod(item.period) }}
              </li>
              <li class="flex-item" :data-label="lang.financial.bills.periodicals.datatable.headers.date">
                {{ item.date }}
              </li>
              <li class="flex-item" :data-label="lang.financial.bills.periodicals.datatable.headers.title">
                {{ item.title }}
              </li>
              <li class="flex-item" :data-label="lang.financial.bills.periodicals.datatable.headers.value">
                {{ formatCurrency(item.value) }}
              </li>
              <li class="flex-item" :data-label="lang.financial.bills.periodicals.datatable.headers.last_paid">
                {{ formatDate(item.last_paid, false) }}
              </li>
              <li class="flex-item" :data-label="lang.financial.bills.periodicals.datatable.headers.next_due">
                ...
              </li>
              <li class="flex-item actions-row" :data-label="lang.financial.bills.periodicals.datatable.headers.actions">
                <Actions
                  :value="item"
                  @view="viewDialog(item)"
                  @edit="editDialog(item)"
                  :subpage="subpage"
                />
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Employee from '@/components/users/templates/Employee'
import Save from '../Save'
import Actions from './Actions'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import list from '@/mixins/defaults/list_dialog'
import periodicals from '../mixins/index'

export default {
  components: { DataTable, Employee, Save, Actions },
  mixins: [ appdata, utils, list, periodicals ],
  props: {
    subpage: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      default: { ...defaults.blank.financial.periodicals[this.subpage] },
      pageName: 'bills.periodicals'
    }
  },
  computed: {
    data () {
      (this.get_data || {}).financial
      let getter = ((this.get_data || {}).financial || {}).periodicals || [],
          type = (this.subpage === 'bills' ? 2 : 1)
      return getter.filter(per => per.type === type)
    }
  }
}
</script>

<style src="../styles/list.scss" lang="scss"></style>
